import {Field,ErrorMessage } from "formik";
import React  from "react";

function Select(props){
    const {questionName, name ,options, ...rest} = props
    return (<>
        {!!questionName &&
            <h2 className="card_medicine_heading">{questionName}</h2>
        }
        <Field as="select"  name={name} {...rest} > 
        {
            options.map((option, ind) => {
             return (
                  <option key={ind} value={option.id} >{option.name}</option>
             )
            })
        }
        </Field> 
        <ErrorMessage name={name} />
    </>)
}
export default Select 